if(!customElements.get('silk-collection'))customElements.define('silk-collection',class extends HTMLElement{
 connectedCallback(){
  this.controller=new AbortController();const signal=this.controller.signal;
  this.firstColour='champagne';this.secondColour='rose';this.offer='single';this.busy=false;
  this.addEventListener('click',e=>{
   const first=e.target.closest('button[data-colour]');
   const second=e.target.closest('[data-second-colour]');
   if(first){
    this.firstColour=first.dataset.colour;
    const thumb=this.querySelector('.sr-thumb[data-colour="'+this.firstColour+'"]');
    if(thumb){
     const main=this.querySelector('.sr-main');main.src=thumb.querySelector('img').src;main.alt=thumb.dataset.label+' silk gift set';
     this.querySelector('.sr-colour-name').textContent=thumb.dataset.label;
     this.querySelector('.sr-stage-bottom>span').textContent=String(thumb.dataset.index).padStart(2,'0')+' / '+String(this.querySelectorAll('.sr-thumb').length).padStart(2,'0');
     this.querySelectorAll('[data-colour]').forEach(x=>x.setAttribute('aria-pressed',String(x.dataset.colour===this.firstColour)));
    }
   }
   if(second){
    this.secondColour=second.dataset.secondColour;this.querySelector('.sr-second-name').textContent=second.dataset.label;
    this.querySelectorAll('[data-second-colour]').forEach(x=>x.setAttribute('aria-pressed',String(x===second)));
   }
   if(e.target.closest('.sr-coming')&&!this.querySelector('.sr-coming').disabled)this.addToCart();
  },{signal});
  this.addEventListener('change',e=>{
   if(!e.target.matches('.sr-offers input'))return;
   this.offer=e.target.value;const duo=this.offer==='duo';const total=duo?'$269.00 USD':'$149.00 USD';
   this.querySelector('.sr-second-colour').hidden=!duo;
   this.querySelector('.sr-total-price').textContent=total;this.querySelector('.sr-product-line>span').textContent=total;
   this.querySelector('.sr-total-label').textContent=duo?this.dataset.duoLabel:this.dataset.singleLabel;
   this.querySelector('.sr-first-label').textContent=duo?this.dataset.firstLabel:this.dataset.colourLabel;
   this.querySelector('.sr-sticky>div>span').textContent=total;
  },{signal});
  this.reveal=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('sr-visible');this.reveal.unobserve(e.target);}}),{threshold:.08});
  this.classList.add('sr-motion');this.querySelectorAll('[data-sr-reveal]').forEach(el=>this.reveal.observe(el));
  this.purchaseObserver=new IntersectionObserver(entries=>{this.querySelector('.sr-sticky').hidden=entries[0].isIntersecting;});
  this.purchaseObserver.observe(this.querySelector('.sr-coming'));
 }
 async addToCart(){
  if(this.busy||this.dataset.launchReady!=='true')return;
  const button=this.querySelector('.sr-coming');const message=this.querySelector('.hi-cart-message');
  const variants=JSON.parse(this.querySelector('.hi-variant-data').textContent)[this.offer]||[];
  const variant=variants.find(v=>v.first===this.firstColour&&(this.offer==='single'||v.second===this.secondColour));
  if(!variant||!variant.available){message.textContent=this.dataset.cartError;return;}
  this.busy=true;button.disabled=true;button.setAttribute('aria-busy','true');button.textContent=this.dataset.cartBusy;message.textContent='';
  try{
   const response=await fetch(this.dataset.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]}),signal:this.controller.signal});
   const result=await response.json();
   if(!response.ok)throw new Error(result.description||this.dataset.cartError);
   window.location.assign(this.dataset.cartUrl);
  }catch(error){
   if(error.name!=='AbortError')message.textContent=this.dataset.cartError;
   this.busy=false;button.disabled=false;button.removeAttribute('aria-busy');button.textContent=this.dataset.cartLabel+' ↗';
  }
 }
 disconnectedCallback(){this.controller?.abort();this.reveal?.disconnect();this.purchaseObserver?.disconnect();}
});
